export enum EnvelopesActionTypes { 
  GET_MY_ENVELOPES = 'GET_MY_ENVELOPES'
}
